const brazilIdIssuers = [
  {
    value: 'RG (SSP ou IFP)',
    text:  'RG (SSP ou IFP)',
  },
  {
    value: 'Carteira de Motorista (DETRAN)',
    text:  'Carteira de Motorista (DETRAN)',
  },
  {
    value: 'Documento Militar ou Polícia Federal (DPF, MMA, MEX, MAE)',
    text:  'Documento Militar ou Polícia Federal (DPF, MMA, MEX, MAE)',
  },
  {
    value: 'Conselhos de Classe (OAB, CRM, CREA, CRC, CRA, outros)',
    text:  'Conselhos de Classe (OAB, CRM, CREA, CRC, CRA, outros)',
  },
  {
    value: 'Registro Nacional Estrangeiro (RNE)',
    text:  'Registro Nacional Estrangeiro (RNE)',
  },
];
export default brazilIdIssuers;
